import { string } from 'yargs'

export interface LoanSearchParams {
  searchfield: string
  searchflags: string
  searchvalue: string
  productid?: number | string
  nodeid?: number | string
  tagid?: number | string
}

export interface LoanSearchServerData {
  Data: any[]
}

export interface LoanViewParams {
  LoanID: number | string
  HashSum_LoanID_: string
  page?: string
  MemberID?: number | string
  NominalFlag?: string
  ActiveOperFlag?: number
  RestrDate?: string
  OperationID?: number | string
  HashSum_OperationID_?: string
  StartDate?: string
  EndDate?: string
  AccOperID?: number | string
  AccEntryTypeID?: number | string
  Active?: number
  CollateralID?: number | string
  HashSum_CollateralID_?: string
  LoanEventID?: number | string
  HashSum_LoanEventID?: string
  OperDate?: string
  ResourceID?: number | string
}

export type LoanViewServerData = any

export enum LoanOperPostPages {
  COMMENTS = 'comments',
  NOTEADD = 'noteadd',
  NOTEEDIT = 'noteedit',
  NOTEDELETE = 'notedelete',
  MONITORINGEDIT = 'monitoringedit',
  MONITORINGADD = 'monitoringadd',
  MONITORINGDELETE = 'monitoringdelete',
  CUSTFIELDSUPDATE = 'custfieldsupdate',
}

export enum LoanOperPages {
  RESTRSHORT = 'restrshort',
  RESOURCEUPDATE = 'resourceupdate',
  STOPACCURALS = 'accrualstop',
  UNDOSTOPACCURALS = 'accrualstopundo',
  ADDCONDITION = 'conditionadd',
  DELETECONDITION = 'conditiondelete',
  OFFICERADD = 'officeradd',
  ASSISTANTADD = 'assistantadd',
  OFFICERDELETE = 'officerdelete',
  DELETEASSISTANT = 'assistantdelete',
  DELETEATRNASACTION = 'transactiondelete',
  WRITEOFF = 'writeoff',
  WRITEOFFDATA = 'writeoffdata',
  UNDOWRITEOFF = 'writeoffundo',
  ACCESSPERMADD = 'accesspermadd',
  DELETEPERMISSION = 'accesspermdelete',
  RESERVEMANUAL = 'reservemanual',
  RESERVEAUTO = 'reserveauto',
  LINKCOLLATERAL = 'linkcollateral',
  UNLINKCOLLATERAL = 'unlinkcollateral',
  CLOSEREVOLVING = 'closerevolving',
  DELETETAG = 'tagdelete',
  ADDTAG = 'tagadd',
  UNDOVISA = 'visaundo',
  DISBURSEVALIDATE = 'disbursevalidate',
  DELETE = 'delete',
  DISBURSEULT = 'disburseult',
  VISA = 'visa',
  ARREST = 'arrest',
  UNDOARREST = 'arrestundo',
  AGREEMENTNUMBERUPDATE = 'agreementnumberupdate',
  NODEUPDATE = 'nodeupdate',
  BASE = 'base',
}

export enum LoanViewPages {
  PRINTLOANCOLDETAGREE = 'printloancoldetagree',
  PRINTLOANAGREEMENT = 'printloanagreement',
  UNDOVISA = 'visaundo',
  DISBURSEVALIDATE = 'disbursevalidate',
  PRINTLOANDETAIL = 'printloandetail',
}

export interface LoanRestRServerData {
  Data: any[]
}

export type LoanOperServerData = LoanRestRServerData

export type LoanOperPostBaseParams = {
  LoanID: number | string
  HashSum_LoanID_: string
}

export type PrintLoanParams = LoanViewParams & {
  page: LoanViewPages.PRINTLOANCOLDETAGREE
  CollateralID: number | string
  HashSum_CollateralID_: string
}

export type PrintLoanAgreementParams = LoanViewParams & {
  page: LoanViewPages.PRINTLOANAGREEMENT
  CollateralID: number | string
  HashSum_CollateralID_: string
}

export type UpdateCommentsParams = {
  Comment: string
  CField1: string
  CField2: string
  CField3: string
  CField4: string
} & LoanOperPostBaseParams

export type AddNoteParams = {
  StateID: number | string
  PriorityID: number | string
  TypeID: number | string
  NodeID: number | string
  GDate: string
  Comment: string
  LFLID?: number | string
  FileID?: number | string
  HashSum_FileID_?: string
} & LoanOperPostBaseParams

export type EditNoteParams = AddNoteParams & {
  ID: number | string
} & LoanOperPostBaseParams

export type DeleteNoteParams = {
  ID: number | string
} & LoanOperPostBaseParams

export type AddEditMonitoringParams = {
  ID?: number | string
  HashSum_LoanMonID_?: string
  SDate: string
  TypeID: number | string
  Criterium1: number | string
  Criterium2: number | string
  Criterium3: number | string
  Criterium4: number | string
  Criterium5: number | string
  Criterium6: number | string
  Comment: string
  FileID: number | string
  HashSum_FileID_: string
} & LoanOperPostBaseParams

export type DeleteMonitoringParams = {
  ID: number | string
  HashSum_LoanMonID_: string
} & LoanOperPostBaseParams

export type UpdateCustomFieldsParams = {
  DynFieldData: any
} & LoanOperPostBaseParams

export type LoanRestRShortParams = {
  RebuildTypeID: 1 | 2
  DeferPayables: 1 | 2
  KeepDates: 1 | 2
  page: LoanOperPages.RESTRSHORT
} & LoanOperPostBaseParams

export type LoanOperPostParams = (
  | UpdateCommentsParams
  | AddNoteParams
  | EditNoteParams
  | DeleteNoteParams
  | AddEditMonitoringParams
  | DeleteMonitoringParams
  | UpdateCustomFieldsParams
) & {
  page: LoanOperPostPages
}

export type UpdateResourceIDParams = LoanOperPostBaseParams & {
  ResourceID: number
  page: LoanOperPages.RESOURCEUPDATE
}

export type StopAccuralsParams = LoanOperPostBaseParams & {
  page: LoanOperPages.STOPACCURALS
}

export type UndoStopAccuralsParams = LoanOperPostBaseParams & {
  page: LoanOperPages.UNDOSTOPACCURALS
}

export type AddConditionParams = LoanOperPostBaseParams & {
  page: LoanOperPages.ADDCONDITION
  ID: number
  ChangeDate: string
  InterestRate: number
  InterestTypeID: number
  PenaltyTypeID: number
  PenaltyPriRate: number
  PenaltyIntRate: number
  AdvFeeTypeID: number
  AdvFeeRate: number
  UCLCRate: number
  CFG_PenaltyGrace: number
  CFG_PenaltyPriority: number
  CFG_AccrueInterestExpire: number
  CFG_AccruePenaltyExpire: number
  CFG_LimitPenalties: number
  CFG_LimitPenalties_Base: number
  CFG_PenaltyDayOne_Type: number
  CFG_PenaltyDayOne_Amount: number
  CFG_PenaltyDayOne_MinAmount: number
  GracePeriod_InterestAccrual: number
  InsRateTypeID: number
  InsRate: number
  CFG_LimitPenalties_AbsAmount: number
  ProcFeeRate: number
  HashSum_ConditionID_: string
  HashSum_LoanID_: string
}

export type DeleteConditionParams = LoanOperPostBaseParams & {
  ConditionID: number
  HashSum_ConditionID_: string
  page: LoanOperPages.DELETECONDITION
}

export type AddOfficerAssistantParams = LoanOperPostBaseParams & {
  page: LoanOperPages.OFFICERADD | LoanOperPages.ASSISTANTADD
  ManagerID: number
  Comment?: string
}

export type DeleteOfficerParams = LoanOperPostBaseParams & {
  ManagerID: number
  page: LoanOperPages.OFFICERDELETE
}

export type DeleteAssistantParams = LoanOperPostBaseParams & {
  ManagerID: number
  page: LoanOperPages.DELETEASSISTANT
}

export type DeleteTransactionParams = LoanOperPostBaseParams & {
  page: LoanOperPages.DELETEATRNASACTION
  OperationID: number
  HashSum_OperationID_: string
}

export type WriteOffParams = LoanOperPostBaseParams & {
  page: LoanOperPages.WRITEOFF
  Comment?: string
  Comment2?: string
  writeoffblacklist: 0 | 1
}

export type WriteOffUndoParams = LoanOperPostBaseParams & {
  page: LoanOperPages.UNDOWRITEOFF
}

export type WriteOffDataParams = LoanOperPostBaseParams & {
  page: LoanOperPages.WRITEOFFDATA
}

export type AddPermissionParams = LoanOperPostBaseParams & {
  page: LoanOperPages.ACCESSPERMADD
  ID: number
}

export type DeletePermissionParams = LoanOperPostBaseParams & {
  page: LoanOperPages.DELETEPERMISSION
  ID: number
}

export type ReserveManualParams = LoanOperPostBaseParams & {
  page: LoanOperPages.RESERVEMANUAL
  ID: number
}

export type ReserveAutoParams = LoanOperPostBaseParams & {
  page: LoanOperPages.RESERVEAUTO
}

export type LinkCollateralParams = LoanOperPostBaseParams & {
  page: LoanOperPages.LINKCOLLATERAL
  CollateralID: string
  HashSum_CollateralID_: string
}

export type UnlinkCollateralParams = LoanOperPostBaseParams & {
  page: LoanOperPages.UNLINKCOLLATERAL
  CollateralID: string | number
  HashSum_CollateralID_: string
}

export type CloseRevolvingParams = LoanOperPostBaseParams & {
  page: LoanOperPages.CLOSEREVOLVING
}

export type DeleteTagParams = LoanOperPostBaseParams & {
  page: LoanOperPages.DELETETAG
  ID: string | number
  TagID: string | number
}

export type AddTagParams = LoanOperPostBaseParams & {
  page: LoanOperPages.ADDTAG
  TagID: number | string
}

export type LoanVisaUndoParams = LoanOperPostBaseParams & {
  page: LoanOperPages.UNDOVISA
}

export type UpdateNodeIDParams = LoanOperPostBaseParams & {
  page: LoanOperPages.NODEUPDATE
  NodeID: number
}

export type DisburseValidateParams = LoanOperPostBaseParams & {
  page: LoanOperPages.DISBURSEVALIDATE
  OperDate: string
  Amount?: number
  AccountID?: number
  HashSum_AccountIDLoanID_?: string
  CashAuth?: number
  OpCodeID?: number
  IDDocID?: number
  HashSum_IDDocID_?: string
  WHLSessionID?: number
  HashSum_WHLSessionID_?: string
  ClientID?: number
  HashSum_ClientID_?: string
  saveData?: boolean
}

export type LoanDeleteParams = LoanOperPostBaseParams & {
  page: LoanOperPages.DELETE
}

export type DisburseUltParams = LoanOperPostBaseParams & {
  page: LoanOperPages.DISBURSEULT
  HashSum_AccountIDLoanID_?: string
  HashSum_AccountID_?: string | number
  OperDate?: string
  Amount?: number
  AccountID?: number
  CashAuth?: number
  OpCodeID?: number
  WHLSessionID?: number
  HashSum_WHLSessionID_?: number
  ClientID?: number
  HashSum_ClientID_?: string
  IDDocID?: number
  HashSum_IDDocID_?: string
  EntryDetails?: string
}

export type LoanVisaParams = LoanOperPostBaseParams & {
  page: LoanOperPages.VISA
  WHLSessionID: number
  HashSum_WHLSessionID_: string
}

export type BlockLoanParams = LoanOperPostBaseParams & {
  page: LoanOperPages.ARREST
}

export type UndoBlockLoanParams = LoanOperPostBaseParams & {
  page: LoanOperPages.UNDOARREST
}

export type UpdateAgreementNumberParams = LoanOperPostBaseParams & {
  page: LoanOperPages.AGREEMENTNUMBERUPDATE
  AgreementNo: number
}

export type LoanOperParams =
  | LoanRestRShortParams
  | UpdateResourceIDParams
  | StopAccuralsParams
  | UndoStopAccuralsParams
  | AddConditionParams
  | DeleteConditionParams
  | LoanOperPostBaseParams
  | DeleteOfficerParams
  | DeleteAssistantParams
  | DeleteTransactionParams
  | WriteOffParams
  | WriteOffDataParams
  | WriteOffUndoParams
  | AddPermissionParams
  | DeletePermissionParams
  | ReserveManualParams
  | ReserveAutoParams
  | LinkCollateralParams
  | UnlinkCollateralParams
  | CloseRevolvingParams
  | DeleteTagParams
  | LoanVisaUndoParams
  | DisburseValidateParams
  | LoanDeleteParams
  | DisburseUltParams
  | LoanVisaParams
  | BlockLoanParams
  | UndoBlockLoanParams
  | UpdateAgreementNumberParams
  | UpdateNodeIDParams
  | AddTagParams

export type LoanCoverParams = {
  action: string
  LoanID: number | string
  HashSum_LoanID_: string
  AccountID: number | string
  HashSum_AccountIDLoanID_: string
  CalcDate: string
  Interest_Corr: number
  PenaltyInt_Corr: number
  ProcFee_Corr: number
  Insurance_Corr: number
  UCLC_Corr: number
  CashAccountID?: number | string
  HashSum_CashAccountID_?: string
  Nominal_Accent?: undefined | number | string
  CCYCommrate?: number | string
  AdvFee_Cover?: undefined | number | string
  OpCodeID?: number | string
  ClientID?: number | string
  HashSum_ClientID_?: string
  WHLSessionID?: number | string
  HashSum_WHLSessionID_?: string
  Interest_Cover?: number | string
  Principal_Cover?: number | string
  Rate1?: number | string
  Rate2?: number | string

  CoverDate?: string
  IDDocID?: string | number
  HashSum_IDDocID_?: string
} & (
  | {
      chk_Select: string
      chk_Freeze: string
      PenaltyPri_Corr: number
    }
  | {
      PenaltyPri_Corr: number
      chk_Select: string
      chk_Freeze: string
      GROSS_Cover: undefined | number | string
      GROSS_Cover_EQ: undefined | number | string
      Principal_Cover: number | string
      EventTypeID: number
    }
)

export type LoanCoverServerData = LoanViewServerData

export interface LoanAddParams {
  action: string
  SequenceID: number | string
  HashSum_SequenceID_: string
  ClientID: number | string
  HashSum_ClientID_: string
  AppID: number | string
  HashSum_AppID_: string
  Amount: number | string
  CCY: string
  DisburseDate: string
  WHLSessionID: number
  HashSum_WHLSessionID_: string
  DynFieldData: string
  HashSum_SequenceIDAppID_?: string
}

export interface LoanAddServerData {
  Data: {
    ID: number
    HashSum_LoanID_: string
  }
}

export interface LoanScheduleParams {
  action: string
  AppID: number | string
  HashSum_AppID_: string
  SequenceID?: string
  HashSum_SequenceIDAppID_?: string
  Amount?: number | string
  CCY?: string
  StartDate?: string
  FirstInstDate?: string | undefined
  WeekDays?: string
  MonthDays?: string
  SkipDirection?: number
  ConsiderHolidays?: number | string
  OtherExpenses_Pre?: number | string
  OtherExpenses_Post?: number | string
  Rounding?: number | string
  sDate?: string
}

export type LoanScheduleServerData = LoanViewServerData

export interface LoanFailure {
  message: string
}

export enum LoanServiceErrorCode {
  GENERAL,
}
